import { Priority } from "../../../../../../../utils/enums/priority"
import { DraggableItem } from "../components/catalogOption/components/draggableItem/types";


const formatFilter = {
  search: 'search',
  createYear: "year",
  month: 'month',
  from: "start_date",
  to: "end_date",
  status: 'status',
}


const priorities = [
  {label: 'Urgente', value: Priority.URGENT},
  {label: 'Alta', value: Priority.HIGH},
  {label: 'Media', value: Priority.MEDIUM},
  {label: 'Baja', value: Priority.LOW}
]

function filterTopLevelItems(items: DraggableItem[], search: string): DraggableItem[] {
  if (!search.trim()) return items;

  const searchLower = search.toLowerCase();

  return items.filter((item) =>
    item.label.toLowerCase().includes(searchLower)
  );
}

const generateId = (): number => {
  //const timestamp = Date.now();
  const random = Math.floor(Math.random() * 10000);
  return random;
};


export {
  formatFilter,
  priorities,
  filterTopLevelItems,
  generateId
}